export default "__VITE_ASSET__B9Rzi3Kb__"